import deeptrace_logo_transaprent from "../assets/deeptrace_logo_transparent.png";
import adroitUIwhitebg from "../assets/adroitUIwhitebg.png";
import qunataMindLogo from "../assets/quantaMindLogo.png";
import deeptrace from "../assets/deeptrace-dashboard.png";
import adroitUIhome from "../assets/adroitUIhome.png";
import quantamind from "../assets/quantamind.png";
import deeptraceLanding from "../assets/deeptrace-landing.png";
import deeptracesignup from "../assets/deeptrace-signup.png";
import deeptraceUpload from "../assets/deeptrace-upload.png";
import deeptraceWorkflow from "../assets/workflow_diagram_New.png";
import quantaGames from "../assets/games dashboarddark.png";
import quantaMeditate from "../assets/meditation session.png";

import wordle from "../assets/wordle.png";
import questionnaire from "../assets/questionnaire.png";
import journal from "../assets/your journaldark.png";
import EdunateLogo from "../assets/Edunate.png";
import EdunateLanding from "../assets/Edunate-landing.png";
import edunate1 from "../assets/edunate-working1.png";
import edunate2 from "../assets/edunate-working2.png";
import edunate3 from "../assets/edunate-working3.png";
import edunate4 from "../assets/edunate-working4.png";
import edunate5 from "../assets/edunate-working5.png";
import edunate6 from "../assets/edunate-working6.png";
import ethxplore from "../assets/ethxplore.png";
import healthbuxLogo from "../assets/health_Bux_logo_transparent.png";
import healthbux1 from "../assets/healthbux1.png";
import healthbux2 from "../assets/healthbux2.png";
import healthbux3 from "../assets/healthbux3.png";
import healthbux4 from "../assets/healthbux4.png";
import healthbux5 from "../assets/healthbux5.png";
import healthbux6 from "../assets/healthbux6.png";
import healthbux7 from "../assets/healthbux7.png";
import healthbux8 from "../assets/healthbux8.png";
import healthbux9 from "../assets/healthbux9.png";
import naiLanding from "../assets/nai-landing.png";
import ecdsaSS from "../assets/ecdsaSS.png";
import fallbackIcon from "../assets/fallbackIcon.png";
import fallbackIconDesign from "../assets/fallbackIconDesign.png";
import latentNavLogo from "../assets/latentNavLogo.png";
import cgl_landing from "../assets/cgl_landing.png";
import CGLArchitecture from "../assets/CGLArchitecture.png";
import CGLHome from "../assets/CGLHome.png";
import CGLUserProfile from "../assets/CGLUserProfile.png";
import CGLProblems from "../assets/CGLProblems.png";



const projectsData = [
    {
        ProjectId: 0,
        ProjectName: "Code's Got Latent",
        ProjectTagline: "A Competitive Programming Platform, but with a Twist of Latent!",
        ProjectDescription: "<p><b>Code's Got Latent</b> is a full-stack <b>competitive programming platform</b> inspired by LeetCode and Codeforces, where ratings change based on users’ rank predictions (custom Elo-style rating algorithm), adding a unique twist to contests. <br/><br/> Integrated a <b>self-hosted Judge0 server</b> to securely execute and evaluate <b>multi-language code submissions</b>, implementing <b>asynchronous job handling, queue management</b>, and <b>real-time status updates.</b> Proudly completed more that <b>500+ user signups</b> on the platform. Co-created this platform with - <a href='https://www.linkedin.com/in/hiteshgupta201105' target='_blank'>@Hitesh Gupta</a></p>",
        ProjectTechUsed: ["JavaScript", "React", "TailwindCSS", "Node.js", "Express", "PostgreSQL", "Prisma ORM", "Web Sockets"],
        ProjectLinks: ["https://www.github.com/HitG010/codegotlatent", "https://www.codegotlatent.com"],
        ProjectLogo: latentNavLogo,
        ProjectImages: [cgl_landing, CGLArchitecture, CGLHome, CGLUserProfile, CGLProblems, ],
        ProjectVideo: [],
        thumbnailImg: cgl_landing,
    },
    {
        ProjectId: 1,
        ProjectName: "DeepTrace",
        ProjectTagline: "Blockchain and Machine Learning based Deepfake Detection platform. ",
        ProjectDescription: "<p><b>DeepTrace</b> is an innovative blockchain and machine learning-based platform designed to combat the <b>growing issue of deepfake videos</b> by leveraging advanced technology and <b>ensuring user privacy</b>. By utilizing the immutable and decentralized nature of blockchain, DeepTrace delivers a highly accurate and trustworthy solution for detecting and mitigating deepfake content worldwide.</p>",
        ProjectTechUsed: ["JavaScript", "React", "TailwindCSS", "Node.js", "MongoDB", "Express", "Solidity", "Flask", "Figma"],
        ProjectLinks: ["https://www.github.com/HitG010/DeepTrace"],
        ProjectLogo: deeptrace_logo_transaprent,
        ProjectImages: [deeptrace, deeptraceLanding, deeptracesignup, deeptraceUpload, deeptraceWorkflow],
        ProjectVideo: ["https://www.youtube.com/embed/k2KG_4mlOEo"],
        thumbnailImg: deeptrace,
    },
    {
        ProjectId: 2,
        ProjectName: "AdroitUI",
        ProjectTagline: "TailwindCSS Components UI Library for React.",
        ProjectDescription: "<p><b>AdroitUI</b> is a comprehensive <b>Tailwind CSS component library</b> designed to help you define and implement <b>your own custom design system</b> seamlessly. With over 20+ finely crafted and editable components, Adroit UI eliminates the hassle of managing complex Tailwind CSS code, allowing you to focus on building stunning and consistent user interfaces.</p><br/><p>This project gained <b>3000+ downloads</b> in the first 3 months.</p>",
        ProjectTechUsed: ["React", "Vite", "TailwindCSS", "NPM", "Storybook", "Figma"],
        ProjectLinks: ["https://www.github.com/kartikbindra/adroit-ui", "https://npmjs.com/package/adroit-ui", "https://www.figma.com/design/rnDRwMjWKW0QrI1Mjns2gO/Adroit-UI-Design-System?node-id=0-1&t=VLGKp07fWfMa4Bj5-1"],
        ProjectLogo: adroitUIwhitebg,
        ProjectImages: [adroitUIhome],
        ProjectVideo: [],
        thumbnailImg: adroitUIhome,
    },
    {
        ProjectId: 3,
        ProjectName: "QuantaMind",
        ProjectTagline: "A Self-Help Mental Health Companion.",
        ProjectDescription: "<p>QuantaMind is a user-centric, technology-driven solution to provide personalized, stigma-free, and sustainable <b>mental health support</b> to individuals facing stressors and challenges in their daily lives, especially those in remote areas or with limited resources. This makes the work of doctors and psychiatrists easier by <b>aiding in more accurate and quicker patient analysis</b>.</p>",
        ProjectTechUsed: ["HTML", "CSS", "JavaScript", "EJS", "Node.js", "Express", "Firebase", "Figma"],
        ProjectLinks: ["https://www.github.com/kartikbindra/quantamind", "https://quantamind.dev"],
        ProjectLogo: qunataMindLogo,
        ProjectImages: [quantamind, quantaMeditate, journal, questionnaire, wordle, quantaGames],
        ProjectVideo: ["https://www.youtube.com/embed/nC0nxS_cI1Q"],
        thumbnailImg: quantamind,
    },
    {
        ProjectId: 4,
        ProjectName: "Edunate",
        ProjectTagline: "An EduFI Alumni Donation Platform.",
        ProjectDescription: "<p>Edunate is an EduFI platform designed to streamline the donation process for educational institutions. By leveraging blockchain technology and robust AI/ML techniques, Edunate ensures <b>transparency, traceability, and accountability</b> for every donation made. The platform empowers alumni to contribute to educational institutions in a secure and efficient manner, while <b>ensuring that their donations are utilized effectively</b>. All three, <b>students, alumni, and institutions</b> can interact seamlessly on the platform, creating a collaborative ecosystem that drives positive change in the education sector.</p>",
        ProjectTechUsed: ["JavaScript", "React", "TailwindCSS", "Node.js", "MongoDB", "Express", "Solidity", "Figma", "Gemini API", "Ethers.js", "EDUChain Blockchain"],
        ProjectLinks: ["https://www.github.com/HitG010/Edunate"],
        ProjectLogo: EdunateLogo,
        ProjectImages: [EdunateLanding, edunate1, edunate2, edunate3, edunate4, edunate5, edunate6],
        ProjectVideo: ["https://www.youtube.com/embed/iIP5pGSB1Cg"],
        thumbnailImg: EdunateLanding,
    },
    {
        ProjectId: 5,
        ProjectName: "ECDSA Encryption",
        ProjectTagline: "Replicating secure ECDSA Node Transactions on Blockchain.",
        ProjectDescription: "<p>This project is an example of using a client and server to facilitate transfers between different addresses on a blockchain network. Although, Since there is just a single server on the back-end handling transfers, this is clearly very centralized. But, this project is focused on replicating the secure ecdsa public key cryptography for sending and verifying transactions.</p>",
        ProjectTechUsed: ["JavaSript", "Node.js", "Express", "Ethers.js", "Cryptography"],
        ProjectLinks: ["https://github.com/kartikbindra/ecdsa-encryption"],
        ProjectLogo: fallbackIcon,
        ProjectImages: [ecdsaSS],
        ProjectVideo: [],
        thumbnailImg: ecdsaSS,
    },
    {
        ProjectId: 6,
        ProjectName: "EthXplore",
        ProjectTagline: "Ethereum Blockchain Block Explorer.",
        ProjectDescription: "<p>EthXplore is a Ethereum Block Explorer that gives you the ability to access and view the real-time data from the ethereum blockchain network. THe real-time data can include information about the blockchain network, blocks in the blockchain, transactions in a block, accounts and many other things!</p>",
        ProjectTechUsed: ["JavaScript", "React", "TailwindCSS", "Ethers.js", "Alchemy API"],
        ProjectLinks: ["https://github.com/kartikbindra/EthXplore-Ethereum-Block-Explorer", "https://eth-xplore.vercel.app/"],
        ProjectLogo: fallbackIcon,
        ProjectImages: [ethxplore],
        ProjectVideo: [],
        thumbnailImg: ethxplore,
    },
    {
        ProjectId: 7,
        ProjectName: "National Archives of India - UI/UX Revamp",
        ProjectTagline: "UI/UX design revamp for the National Archives of India Website.",
        ProjectDescription: "<p>This UX/UI design rebranding for National Archives of India Website was done for a UX/UI design hackathon organised by National Archives of India and Abhilekh Patal portal. This case study includes the falws of the existing website and how they can be improved. More can be found out on the behance page of the same.</p>",
        ProjectTechUsed: ["Figma", "Photoshop"],
        ProjectLinks: ["https://www.behance.net/gallery/217668769/National-Archives-of-India-Website-UIUX-Revamp"],
        ProjectLogo: fallbackIconDesign,
        ProjectImages: [naiLanding],
        ProjectVideo: ["https://www.behance.net/embed/project/217668769?ilo0=1"],
        thumbnailImg: naiLanding,
    },
    {
        ProjectId: 8,
        ProjectName: "HealthBux - Brand Identity",
        ProjectTagline: "Brand Identity Design for HealthBux - A cloud kitchen service for Gym-freaks and Fitness-lovers!",
        ProjectDescription: "<p>This project involved creating a comprehensive brand identity for HealthBux, a cloud kitchen service tailored for gym enthusiasts and fitness lovers. The brand identity design encompassed logo creation, color schemes, typography, and marketing materials to ensure a cohesive and appealing visual presence. The goal was to reflect the energetic and health-focused nature of the service, making it attractive to its target audience.</p>",
        ProjectTechUsed: ["Figma", "Photoshop"],
        ProjectLinks: ["https://www.behance.net/gallery/199974001/HealthBux-Brand-Identity"],
        ProjectLogo: healthbuxLogo,
        ProjectImages: [healthbux1, healthbux2, healthbux3, healthbux4, healthbux5, healthbux6, healthbux7, healthbux8, healthbux9],
        ProjectVideo: ["https://www.behance.net/embed/project/199974001?ilo0=1"],
        thumbnailImg: healthbux1,
    }
];

// const logos = [deeptrace_logo_transaprent, adroitUIwhitebg, qunataMindLogo];

// const imgs = [
//     [deeptrace, deeptraceLanding, deeptracesignup, deeptraceUpload, deeptraceWorkflow],
//     [adroitUIhome],
//     [quantamind, quantaMeditate, journal, questionnaire, wordle, quantaGames],
// ];

export { projectsData };
